import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { catchError, mergeMap } from 'rxjs/operators';
import { LoginAction } from '../../actions/login/login-action';
import { LoginErrorAction } from '../../actions/login/login-error-action';
import { of } from 'rxjs';
import { LoginSuccessAction } from '../../actions/login/login-success-action';
import { GetBijbEventsAction } from '../../actions/bijb-event/get-events-action';
import { GetCurrentAccountAction } from '../../actions/current-account/get-current-account-action';

@Injectable()
export class LoginEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public Login = createEffect(() => this.actions
    .pipe(
      ofType(LoginAction.type),
      mergeMap(action => {
        const loginAction = <LoginAction>action;
        return this.api.login(loginAction.email, loginAction.password)
          .pipe(
            mergeMap(() => {
              return of(new LoginSuccessAction(), new GetBijbEventsAction(), new GetCurrentAccountAction());
            }),
            catchError(e => {
              return of(new LoginErrorAction(e));
            })
          );
      })
    ));
}
